import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import navigation from "./modules/navigation";
import swatch from "./modules/swatch";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: "securytyweb",
  storage: localStorage
});

export const store = new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    isLoading: false,
    isSnackBar: false,
    token: String,
    esignToken: String,
    operation: String,
    operationUuid: String,
    domainUuid: String,
    documentUuid: String,
    videoUuid: String,
    cellphone: String,
    signBoxName: String,
    attachDocumentUuid: String,
    userEmail: "",
    userUid: String,
    userToken: String,
    userData: {},
    userLoggedIn: false,
    credits: {},
    usedones: {}
  },
  getters,
  mutations,
  actions,
  modules: {
    navigation,
    swatch
  }
});
